import { AxiosResponse } from "axios";
import axiosInstance from "../../../api/axios";

export const loginUser = async (values: any) => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.post(
      "/auth/login",
      {
        email: values.username,
        password: values.password,
      }
    );
    console.log("Login successful:", response.data);
    return {
      data: response.data,
      success : true
    };
    // Handle success (e.g., navigate to another page)
  } catch (error: any) {
    console.error("Login failed:", error.response?.data || error.message);
    // Handle failure (e.g., show an error message)
    return {
      data: error.response?.data,
      success: false,
    };
  }
};
